import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BrainLoadingWrapper from '../../../core/components/molecules/BrainLoading';
import useGetLesson from '../hook/useGetLesson';

const RedirectPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, isLoading } = useGetLesson(id || '');

  useEffect(() => {
    if (!data) return;

    const materia = data?.ancestors?.area?.slug;
    const subarea = data?.ancestors?.subarea?.slug;
    const subject = data?.subjects?.at(0)?.slug;
    const slug = data?.slug;

    const url = `/disciplinas/${materia}/modulo/${subarea}/assunto/${subject}/videoaula/${slug}`;
    navigate(url);
  }, [data]);

  if (isLoading) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <BrainLoadingWrapper />
      </div>
    );
  }

  return <></>;
};

export default RedirectPage;
